import React from 'react';
import { message } from 'antd';
import fail from '../../static/msg-fail.svg';
import success from '../../static/msg-success.svg';

export default {
  error: ({ duration = 3, content }) => {
    message.destroy();
    message.success({
      duration,
      content,
      icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
    });
  },
  success: ({ duration, content }) => {
    message.destroy();
    message.success({
      duration,
      content,
      icon: <img className="ant-message-custom-img" src={success} alt="error" />,
    });
  },
};
